import { useEffect, useState } from 'react';
import { Board } from '../../../components/Board';
import { NavButton } from '../../../components/NavButton';
import { useSchoolClass } from '../../../hooks/useSchoolClass';
import { LoadData, User } from '../../../types';
import { useNavigate } from 'react-router-dom';
import { verifyRoutePermissions } from '../../../globalFunctions';
import styles from './styles.module.scss';
import { Pergunta } from './pergunta';
import axios, { AxiosRequestConfig } from 'axios';
import pop from '../../../assets/sounds/pop.mp3';
import selected from '../../../assets/sounds/destiny.mp3';
import chooseMK from '../../../assets/sounds/selectMK.mp3';
import { Leaderboard } from './leaderboard';
export type Student = {
    id: number;
    name: string;
    image?: { url: string };

    correct: number;
    q1: string;
    q2: string;
    q3: string;
    q4: string;
    q5: string;
};

export const Game = () => {
    const [studentsWithImage, setStudentsWithImage] = useState<Student[]>([]);
    const schoolClasses: LoadData = useSchoolClass();
    const [escola, setEscola] = useState<string | undefined>(undefined);
    const [isRolling, setIsRolling] = useState(false);
    const [Aluno1, setAluno1] = useState<Student | null>(null);
    const [Aluno2, setAluno2] = useState<Student | null>(null);
    const [Escolhido, setEscolhido] = useState<Student | null>(null);
    const [start, setStart] = useState<boolean>(false);
    const [time, setTime] = useState<number>(30);
    const navigate = useNavigate();
    const [pergunta, setPergunta] = useState<any>();
    const [banco, setBanco] = useState<any>();
    const [perguntas, setPerguntas] = useState<any>([]);
    const [bancos, setBancos] = useState<any>([]);
    const [userAuth, setUserAuth] = useState<User>({} as User);
    const [excluidos, setExluidos] = useState<number[]>([]);
    const [conexoes, setConexoes] = useState<any[]>([]);
    const [musica, setMusica] = useState<any>();
    const [musicaTema, setMusicaTema] = useState<string>('');
    const [encerrado, setEncerrado] = useState<boolean>(false);
    const [perguntasUsadasIds, setPerguntasUsadasIds] = useState<number[]>([]); // Novo estado
    const requestConfig: AxiosRequestConfig = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: `Bearer ${userAuth.id}`,
            Accept: 'application/json'
        }
    };
    const [filaA, setFilaA] = useState<Student[]>([]);
    const [filaB, setFilaB] = useState<Student[]>([]);

    useEffect(() => {
        verifyRoutePermissions(
            ['auth', 'email.verified', 'not.pending.update', 'logicmanager.classes'],
            navigate
        );
        fetchMusicaTema();
    }, [navigate]);

    useEffect(() => {
        fetchQuestoes();
    }, [start]);

    console.log(perguntas);

    const fetchQuestoes = async () => {
        try {
            const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/perguntas`);
            console.log(data);
            const formattedData = data.map((q: any) => ({
                enunciado: q.title,
                a: q.q1,
                b: q.q2,
                c: q.q3,
                d: q.q4,
                e: q.q5,
                correct: q.correct,
                resolucao: q.resolucao
            }));
            setPerguntas(Array.isArray(formattedData) ? formattedData : []);
            if (formattedData.length > 0) {
                setPergunta(perguntaAleatoria()); // Define a primeira pergunta
            }
        } catch (error) {
            console.error('Erro ao buscar publicações:', error);
        }
    };
    const fetchBancos = async () => {
        try {
            const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/bancos`);
            console.log(data);
            setBancos(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error('Erro ao buscar publicações:', error);
        }
    };
    const getClassByName = (name: string): any => schoolClasses?.data?.find(c => c.name === name);
    const getBancoById = (id: number): any => bancos.find(c => c.id == id);
    function wait(s) {
        return new Promise(resolve => setTimeout(resolve, s * 1000));
    }

    const sorteiaDupla = (lista: Student[]) => {
        if (!lista || lista.length < 2) return [null, null];

        const idx1 = Math.floor(Math.random() * lista.length);
        let idx2 = idx1;
        while (idx2 === idx1) {
            idx2 = Math.floor(Math.random() * lista.length);
        }

        // retorna apenas os IDs para evitar referências inconsistentes entre arrays/estados
        return [lista[idx1].id, lista[idx2].id] as (number | null)[];
    };

    // retorna o objeto "canônico" a partir do estado studentsWithImage (ou filas)
    const findStudentById = (id: number | null) => {
        if (id == null) return null;
        return (
            studentsWithImage.find(s => s.id === id) ||
            filaA.find(s => s.id === id) ||
            filaB.find(s => s.id === id) ||
            null
        );
    };

    const placeholderImages = [
        'https://imgur.com/KyLbBRZ.png',
        'https://imgur.com/RMoaR0W.png',
        'https://imgur.com/XYJgCC6.png',
        'https://imgur.com/OJaWAIm.png',
        'https://imgur.com/w4owfuS.png'
    ];
    const adicionarPonto = (alunoId: number) => {
        setStudentsWithImage(prevStudents =>
            prevStudents.map(aluno =>
                aluno.id === alunoId
                    ? { ...aluno, correct: aluno.correct ? aluno.correct + 1 : 1 } // Incrementa a pontuação
                    : aluno
            )
        );
    };
    const fetchMusicaTema = async () => {
        try {
            const { data } = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/combate`,
                requestConfig
            );
            setMusicaTema(data.map(som => som.musica));
        } catch (error) {
            console.error('Erro ao buscar publicações:', error);
        }
    };

    const Roll = async () => {
        setEscolhido(null);

        if (filaA.length < 2) {
            const alunoRemanescente = filaA.length === 1 ? filaA[0] : null;

            // Reconstroi a fila A:
            // Se sobrou 1 aluno em filaA, ele vai para o final da filaB
            let novaFilaB = alunoRemanescente ? [...filaB, alunoRemanescente] : filaB;

            // Inicia a nova fila A com a ordem da fila B (Fila B se torna a nova Fila A)
            setFilaA(novaFilaB);
            setFilaB([]);
            setEscolhido(findStudentById(alunoRemanescente?.id ?? null));
            setIsRolling(false);

            return;
        }

        setIsRolling(true);

        const originalFilaA = [...filaA];
        const audio = new Audio(chooseMK);
        audio.play();
        let currentPairIds: (number | null)[] = [null, null];

        for (let i = 1; i < 25; i++) {
            currentPairIds = sorteiaDupla(originalFilaA as Student[]);
            const id1 = currentPairIds[0];
            const id2 = currentPairIds[1];
            const s1 = findStudentById(id1);
            const s2 = findStudentById(id2);
            setAluno1(s1);
            setAluno2(s2);
            await wait(0.2);
        }
        audio.pause();

        const selectedSound = new Audio(selected);
        selectedSound.play();

        const finalIndex = Math.floor(Math.random() * 2);
        const chosenId = currentPairIds[finalIndex];
        const otherId = currentPairIds[finalIndex === 0 ? 1 : 0];
        const chosenStudent = findStudentById(chosenId);
        const otherStudent = findStudentById(otherId);

        await wait(1);
        setEscolhido(chosenStudent);

        if (chosenStudent && otherStudent) {
            const alunosRemoverIds = [chosenStudent.id, otherStudent.id];
            setFilaA(prev => prev.filter(a => !alunosRemoverIds.includes(a.id)));
            setFilaB(prev => [...prev, chosenStudent]);
            setFilaA(prev => [...prev, otherStudent]);
        }

        setIsRolling(false);
    };

    useEffect(() => {
        if (start) {
        } else {
            Roll();
        }
    }, [start]);

    const perguntaAleatoria = () => {
        const selectedBanco = getBancoById(banco);
        if (!selectedBanco || !selectedBanco.perguntas || selectedBanco.perguntas.length === 0) {
            return undefined;
        }
        const todosOsIds = selectedBanco.perguntas.map((q: any) => q.id);
        let idsDisponiveis = todosOsIds.filter((id: number) => !perguntasUsadasIds.includes(id));
        let novoPerguntasUsadasIds = perguntasUsadasIds;
        if (idsDisponiveis.length === 0) {
            console.log('Todas as perguntas foram usadas. Reiniciando o ciclo!');
            setPerguntasUsadasIds([]);
            novoPerguntasUsadasIds = [];
            idsDisponiveis = todosOsIds;
        }

        const indiceSorteado = Math.floor(Math.random() * idsDisponiveis.length);
        const idPerguntaSorteada = idsDisponiveis[indiceSorteado];
        const perguntaSorteada = selectedBanco.perguntas.find(
            (q: any) => q.id === idPerguntaSorteada
        );

        setPerguntasUsadasIds([...novoPerguntasUsadasIds, idPerguntaSorteada]);
        return perguntaSorteada;
    };

    const startGame = async () => {
        const musica = new Audio();
        musica.src = musicaTema[Math.floor(Math.random() * musicaTema.length)];
        musica.play();
        setMusica(musica);
        setPergunta(perguntaAleatoria());
        setStart(true);
        setTime(30);
        const con = setInterval(() => {
            setTime(prevTime => prevTime - 1);
        }, 1000);
        setConexoes(prev => [...prev, con]);
    };

    let students: Student[] = studentsWithImage
        .map(aluno => ({ ...aluno, name: aluno.name.split(' ')[0] }))
        .sort((a, b) => a.name.localeCompare(b.name))
        .filter(student => !excluidos.includes(student.id));

    useEffect(() => {
        if (escola) {
            const turma = getClassByName(escola);
            if (turma) {
                // Sorteia imagem só uma vez para cada aluno sem imagem
                const alunosComImagem = turma.students.map(aluno => {
                    if (!aluno.image?.url) {
                        const sorteada =
                            placeholderImages[Math.floor(Math.random() * placeholderImages.length)];
                        return { ...aluno, image: { url: sorteada }, correct: 0 };
                    }
                    return aluno;
                });
                setStudentsWithImage(alunosComImagem);
                if (!start) setFilaA(alunosComImagem);
            } else {
                setStudentsWithImage([]);
                setFilaA([]);
            }
            setFilaB([]); // Reinicia a fila B sempre que uma nova turma é selecionada
        }
    }, [escola]);

    useEffect(() => {
        fetchBancos();
    }, []);

    const removerAluno = (id: number) => {
        setExluidos([...excluidos, id]);
        // remove da filaA e filaB
        setFilaA(prev => prev.filter(a => a.id !== id));
        setFilaB(prev => prev.filter(a => a.id !== id));
    };

    const finish = () => {
        setStart(false);
        setTime(30);

        conexoes.map(con => {
            clearInterval(con);
        });

        setConexoes([]);
    };

    return (
        <>
            {encerrado ? (
                <Leaderboard students={students} />
            ) : start ? (
                <Pergunta
                    pergunta={pergunta}
                    tempo={time}
                    finish={finish}
                    jogador={students.find(a => a.id === Escolhido?.id) || Escolhido} // <-- sempre busca no students mapeado
                    musica={musica}
                    adicionarPonto={adicionarPonto} // <-- NOVA PROP
                />
            ) : (
                <div className={styles.wrapper}>
                    <Board wrapperClass={styles.board}>
                        <div id='print-section' className={styles.content}>
                            <h1 className={styles.title}>Sortear alunos</h1>
                            <div className={styles.controls}>
                                <select
                                    value={escola ?? ''}
                                    onChange={e => setEscola(e.target.value)}
                                    className={styles.select}
                                >
                                    <option value='' disabled>
                                        Selecione uma turma
                                    </option>
                                    {schoolClasses.data?.map(c => (
                                        <option value={c.name} key={c.id}>
                                            {c.name}
                                        </option>
                                    ))}
                                </select>
                                <select
                                    value={banco ?? ''}
                                    onChange={e => setBanco(e.target.value)}
                                    className={styles.select}
                                >
                                    <option value='' disabled>
                                        Selecione um banco de questões
                                    </option>
                                    {bancos
                                        ?.filter(banco => banco.perguntas?.length > 0)
                                        .map(c => (
                                            <option value={c.id} key={c.id}>
                                                {c.nome}
                                            </option>
                                        ))}
                                </select>
                                <button
                                    className={styles.startButton}
                                    onClick={Roll}
                                    disabled={!escola || students.length < 2 || isRolling || !banco}
                                >
                                    {isRolling ? 'Sorteando...' : 'Iniciar'}
                                </button>
                            </div>
                            <div className={styles.studentsGrid}>
                                {students.map(aluno => (
                                    <div className={styles.studentCard} key={aluno.id}>
                                        <img
                                            className={styles.image}
                                            src={aluno.image?.url}
                                            alt={aluno.name}
                                        />
                                        <p className={styles.studentName}>{aluno.name}</p>
                                        <button
                                            onClick={() => {
                                                removerAluno(aluno.id);
                                            }}
                                            className={styles.remover}
                                        >
                                            ❌
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </Board>
                    <NavButton
                        route='/manager'
                        direction='left'
                        style={{ left: '0.4vw', top: '2vw', zIndex: 20 }}
                    />
                    {(isRolling || Aluno1) && (
                        <div className={styles.vsOverlay} role='dialog' aria-modal='true'>
                            <div className={styles.vsContent}>
                                {!Escolhido ? (
                                    <>
                                        <div className={styles.side}>
                                            <div className={styles.avatarWrap}>
                                                <img
                                                    className={`${styles.avatar}`}
                                                    src={
                                                        (
                                                            students.find(
                                                                a => a.id === Aluno1?.id
                                                            ) || Aluno1
                                                        )?.image?.url
                                                    }
                                                    alt={Aluno1?.name?.split(' ')[0] ?? 'Aluno esquerdo'}
                                                />
                                            </div>
                                            <div className={styles.name}>
                                                {Aluno1?.name?.split(' ')[0] ?? '---'}
                                            </div>
                                        </div>
                                        <div className={styles.center}>
                                            <div className={styles.vsText}>VS</div>
                                        </div>
                                        <div className={styles.side}>
                                            <div className={styles.avatarWrap}>
                                                <img
                                                    className={`${styles.avatar}`}
                                                    src={
                                                        (
                                                            students.find(
                                                                a => a.id === Aluno2?.id
                                                            ) || Aluno2
                                                        )?.image?.url
                                                    }
                                                    alt={Aluno2?.name?.split(' ')[0] ?? 'Aluno direito'}
                                                />
                                            </div>
                                            <div className={styles.name}>
                                                {Aluno2?.name?.split(' ')[0] ?? '---'}
                                            </div>
                                        </div>
                                    </>
                                ) : (
                                    <div className={styles.side}>
                                        <div className={styles.avatarWrap}>
                                            <img
                                                className={`${styles.avatar}`}
                                                src={Escolhido?.image?.url}
                                                alt={Escolhido?.name?.split(' ')[0] ?? 'Aluno escolhido'}
                                            />
                                        </div>
                                        <div className={styles.name}>
                                            {Escolhido?.name?.split(' ')[0] ?? '---'}
                                        </div>
                                    </div>
                                )}
                            </div>
                            {!isRolling && (
                                <button className={styles.closeOverlay} onClick={startGame}>
                                    Jogar
                                </button>
                            )}
                            <button
                                className={`${styles.closeOverlay} ${styles.encerrar}`}
                                onClick={() => {
                                    setEncerrado(true);
                                }}
                            >
                                Encerrar
                            </button>
                        </div>
                    )}
                </div>
            )}
        </>
    );
};